
import React, { ReactNode } from "react";

interface SlideLayoutProps {
  children: ReactNode;
}

const SlideLayout = ({ children }: SlideLayoutProps) => {
  return (
    <div className="py-8 px-4 md:px-8 rounded-2xl bg-white backdrop-blur-sm border border-indigo-200 shadow-lg text-indigo-900">
      {children}
    </div>
  );
};

export default SlideLayout;
